import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { NgbDatepickerI18nDefault } from '@ng-bootstrap/ng-bootstrap';

/** ng-bootstrap 7 headed each datepicker column with the locale's two-letter weekday name ("Mo", "Tu", …). */
const WEEKDAY_LABEL_LENGTH = 2;

/** 1 May 2000 was a Monday; ng-bootstrap numbers weekdays 1 (Monday) to 7 (Sunday). */
const FIRST_MONDAY_OF_MAY_2000 = { year: 2000, monthIndex: 4, day: 1 };
const DAYS_IN_WEEK = 7;

/**
 * Keeps ng-bootstrap 7's two-letter weekday headers ("Mo Tu We …"). ng-bootstrap 12+ defaults to
 * `Intl`'s narrow names ("M T W …"), and `Intl` has no two-letter width, so the short name is cut to two letters —
 * identical to Angular's `TranslationWidth.Short` names that 7.x used for English locales.
 */
@Injectable()
export class TwoLetterWeekdayDatepickerI18n extends NgbDatepickerI18nDefault {
    private readonly weekdayLabels: readonly string[];

    constructor() {
        const locale = inject(LOCALE_ID);

        super();
        const formatter = new Intl.DateTimeFormat(locale, { weekday: 'short', timeZone: 'UTC' });
        this.weekdayLabels = Array.from({ length: DAYS_IN_WEEK }, (_unused, offset) =>
            formatter
                .format(Date.UTC(FIRST_MONDAY_OF_MAY_2000.year, FIRST_MONDAY_OF_MAY_2000.monthIndex, FIRST_MONDAY_OF_MAY_2000.day + offset))
                .slice(0, WEEKDAY_LABEL_LENGTH)
        );
    }

    override getWeekdayLabel(weekday: number): string {
        return this.weekdayLabels[weekday - 1] ?? '';
    }
}
